var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('router-link',{class:_vm.returnCSS,attrs:{"to":_vm.returnPath}},[_vm._v(_vm._s(_vm.returnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }